import { doc, getDoc } from "firebase/firestore";
import { firestore as db } from "../../../../backend/firebaseconfig";

const normaliseEmail = (value = "") => String(value).trim().toLowerCase();

const normaliseRole = (value = "") => String(value).trim();

const asEmailArray = (value) => {
  if (!Array.isArray(value)) return [];

  return value.map((email) => normaliseEmail(email)).filter(Boolean);
};

/**
 * Get all emails related to the current user:
 * - Adviser: uses admins[] from their own adviser document
 * - Administrator: uses advisers[] from their own administrator document
 * - External: uses advisers[] from their own external document
 *
 * @param {string} userEmail
 * @param {string} userRole - "Advisers", "Administrators", "Staff", or "External"
 * @returns {Promise<string[]>}
 */
export async function getRelatedEmails(userEmail, userRole) {
  const normalisedUserEmail = normaliseEmail(userEmail);
  const normalisedUserRole = normaliseRole(userRole);

  if (!normalisedUserEmail || !normalisedUserRole) {
      // console.warn("[getRelatedEmails] Missing userEmail or userRole", {
      //   userEmail,
      //   userRole,
      // });

    return normalisedUserEmail ? [normalisedUserEmail] : [];
  }

  const relatedEmails = new Set([normalisedUserEmail]);

  const roleConfig = {
    Advisers: {
      collectionRole: "Advisers",
      relationshipField: "admins",
    },
    Administrators: {
      collectionRole: "Administrators",
      relationshipField: "advisers",
    },
    Admins: {
      collectionRole: "Administrators",
      relationshipField: "advisers",
    },
    Admin: {
      collectionRole: "Administrators",
      relationshipField: "advisers",
    },
    External: {
      collectionRole: "External",
      relationshipField: "advisers",
    },
    Staff: {
      collectionRole: "Staff",
      relationshipField: null,
    },
  };

  const config = roleConfig[normalisedUserRole];

  if (!config) {
      // console.warn("[getRelatedEmails] Unsupported user role", {
      //   userEmail: normalisedUserEmail,
      //   userRole: normalisedUserRole,
      // });

    return [normalisedUserEmail];
  }

  if (!config.relationshipField) {
    return [normalisedUserEmail];
  }

  try {
    const userRef = doc(
      db,
      "Authorized Members",
      config.collectionRole,
      "Data",
      normalisedUserEmail,
    );

    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
      // console.warn("[getRelatedEmails] User document not found", {
      //   path: `Authorized Members/${config.collectionRole}/Data/${normalisedUserEmail}`,
      //   userEmail: normalisedUserEmail,
      //   userRole: normalisedUserRole,
      // });

      return [normalisedUserEmail];
    }

    const userData = userSnap.data() || {};

    const relationshipEmails = asEmailArray(userData[config.relationshipField]);

    relationshipEmails.forEach((email) => {
      relatedEmails.add(email);
    });

    const finalEmails = Array.from(relatedEmails);

    // console.log("[getRelatedEmails] Finished", {
    //   userRole: normalisedUserRole,
    //   relationshipField: config.relationshipField,
    //   finalEmails,
    //   count: finalEmails.length,
    // });

    return finalEmails;
  } catch (error) {
    // console.error("[getRelatedEmails] Error fetching related emails", {
    //   error,
    //   message: error?.message,
    //   userEmail: normalisedUserEmail,
    //   userRole: normalisedUserRole,
    // });

    return [normalisedUserEmail];
  }
}
